/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useContext, useEffect, useState } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
import {InputLabel} from '@material-ui/core';
// import  useStyles  from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
import copy from "copy-to-clipboard";  
import '../css/Drag.css'
import {APIUPLOAD}            from '../services/APIServices';
import FormHelperText from '@mui/material/FormHelperText';
import elementValidation from '../Component/validation.js';


function FileUpload(props) {
  const {useStyle} = ThemeControls;
  const classes = useStyle();
  const [file, setFile] = useState()
  const [uploadPercentage, setUploadPercentage] = useState();
  const [copyText, setCopyText] = useState('');
  let { id,field_type, field_id,field_apipath,field_disabled,preview,field_label,acceptfile, field_placeholder, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,field_mandatory } = props;
  const { handleChange } = useContext(FormContext)
  const apipath= "uploadFiles/uploadFile";

  const elementField = {id,field_type,field_disabled, field_id,field_apipath, field_label, field_placeholder, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,field_mandatory };
  function handleBlur(){
    elementValidation(elementField)
  }

  async function handleChangeFile(event) {
    try {
      if (event.target.files && event.target.files.length > 0) {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
  
        const formData = new FormData();
        formData.append('file', selectedFile);
  
        const response = await APIUPLOAD(apipath, formData, setUploadPercentage, setFileData);
         

      }
    } catch (error) {
      console.error('Error uploading file:', error);
      // Handle errors, display error messages, etc.
    }
  }
  
 

function setFileData(data){
  //console.log(data)
  const { fileName,uploadFilesLabel,filePath } = data;
  handleChange(field_id,{},uploadFilesLabel);
    setCopyText(filePath);
}

// //console.log(file.name)
 
 const copyToClipboard = () => {
  copy(copyText);
  alert(`You have copied "${copyText}"`);
}

  return (
    <div style={{position:"relative"}}>
            <div className="file-upload-btn">
                <input 
                type="file"  
                id={field_id} 
                className="file-upload-input" 
                onChange={handleChangeFile}  
                // multiple  
                accept={acceptfile}
                />
                <span>@ Attach</span>
            </div>
            <div className='file-names'>{file&&file.name}</div>
            {/* {uploadPercentage && (
            <div className={classes.progrs}>
                <div
                    className={classes.progressBar}
                    role='progressbar'
                    style={{ width: `${uploadPercentage}%` }}
                >
                    {uploadPercentage}%
                    </div>
                </div>
                )} */}
          {field_helperText?<FormHelperText>{field_helperText}</FormHelperText>:null}
    </div>
  );
}

export default FileUpload;

